//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GiftCardPreview from "@/components/shop/conf/GiftCardPreview";
import ShowMediaAsset from "@/components/common/ShowMediaAsset";
import ProductMediaRender from "@/components/shop/conf/ProductMediaRender";
import UiLazyImg from "@/components/Ui/UiLazyImg.vue";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import mpi from "@/plugins/merge";

export default {
  name: "ProductMedia",
  components: {
    GiftCardPreview,
    ShowMediaAsset,
    ProductMediaRender,
    UiLazyImg,
    Swiper,
    SwiperSlide
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isGiftCard: {
      type: Boolean,
      default: false
    },
    showEngravingPlaceholder: {
      type: Boolean,
      default: false,
    },
    mt: {
      type: String,
      default: '',
    },
    selected: {
      type: Object,
      default() {
        return {}
      }
    },
    stage: {
      type: String,
      default: 'configuration-edit',
    },
  },
  data() {
    return {
      dialog: false,
      dialogItem: null,
      showSliderDelay: false,
      sliderValue: 0
    }
  },
  watch: {
    stage(val, oldVal) {
      if (this.info.theme.id !== this.constProductThemes().package && (val === 'box' || oldVal === 'box')) {
        this.resetSliderPosition();
      }
    },
    dialog(val) {
      if (!val) {
        this.dialogItem = null;
      }
    }
  },
  computed: {
    singleSlide() {
      const additionalMedia = this.isGiftCard ? 1 : 0;
      const mediaListLength = this.mediaList.length + additionalMedia;
      return mediaListLength === 1;
    },
    swiperOption() {
      const additionalMedia = this.isGiftCard ? 1 : 0;
      const mediaListLength = this.mediaList.length + additionalMedia;
      let firstBreakpointSlidesPerView = 2.07;
      if (mediaListLength < 3) {
        firstBreakpointSlidesPerView = mediaListLength === 2 ? 2 : 1;
      }
      return {
        mousewheel: {
          forceToAxis: true
        },
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
        breakpoints: {
          600: {
            spaceBetween: 0,
            slidesPerView: firstBreakpointSlidesPerView,
          },
          320: {
            spaceBetween: 0,
            slidesPerView: mediaListLength > 1 ? 1.07 : 1,
          }
        }
      }
    },
    mediaList() {
      if (this.stage === 'box' && this.info.theme.id !== this.constProductThemes().package) {
        return this.info.package?.types?.find(item => item.name === this.$route.query.bc)?.slider_assets?.map((item, index) => ({
          ...item,
          url: item.uri,
          listType: index ? 'media' : 'render',
          images: [item.uri],
          renderIndex: index,
          autoplay: true,
        })) || [];
      }
      const media = this.getMedia();
      const renders = this.getRenders();
      return this.shuffleMedia(renders, media);
    },
    showPagination() {
      return (this.isGiftCard && this.mediaList?.length) || this.mediaList?.length > 1;
    },
    isMilestone() {
      return this.info.theme.id === this.constProductThemes().ringMilestone || this.info.theme.id === this.constProductThemes().braceletMilestone
    }
  },
  methods: {
    resetSliderPosition() {
      this.showSliderDelay = true;
      this.$refs?.slider?.$swiper?.slideTo(0);
      setTimeout(() => {
        this.showSliderDelay = false;
      }, 300);
    },
    async openDialog(item) {
      if(item.listType === 'render' && !document.querySelector(`.render-item-${item.renderIndex}`)) {
        return;
      }
      if (item.listType === 'render') {
        mpi.init({width: 1400, height: 1183});
        this.dialogItem = {
          ...item,
          mergedImage: await mpi.getMergedImage(`.render-item-${item.renderIndex}`, true)
        };
      } else {
        this.dialogItem = item;
      }
      this.dialog = true;
    },
    shuffleMedia(renders, media) {
      const result = [];
      const mediaListSize = renders.length + media.length;
      let index = 0;
      let isRender = true;
      while(index < mediaListSize) {
        const listSource = (isRender || !media.length) && renders.length ? renders : media;
        result.push(...listSource.splice(0,1));
        if (!index || index % 2 === 0) {
          isRender = !isRender;
        }
        index++;
      }
      return result;
    },
    isSingleRender(item) {
      return item.listType === 'render' && this.mediaList?.length === 1;
    },
    checkOddLastColumn(index) {
      const columnOrder = index + 1;
      return columnOrder % 2 !== 0 && columnOrder === this.mediaList.length;
    },
    getMedia() {
      const images = this.info.images ? JSON.parse(JSON.stringify(this.info.images.filter(item => item.device !== 2))) : [];
      const movies = this.info.movies ? JSON.parse(JSON.stringify(this.info.movies.filter(item => item.device !== 2))) : [];
      let mediaList = images.concat(movies).sort((a,b) => a.sort_order - b.sort_order);
      if (this.info.medias_by_attributes && this.selected?.stones?.[0]?.st?.id) {
        mediaList = mediaList.filter(item => item.attribute_id === this.selected.stones[0].st.id);
      }
      mediaList.forEach(item => {
        item.listType = 'media';
      })
      return mediaList;
    },
    rotateImages(src) {
      if (src.includes('-P')) {
        let p = src.split('-P');
        let a = p[1].split('.');
        a[0] = Number(a[0]) + Number(this.sliderValue);
        if (Number(a[0]) > (this.selected.stones.length - 1)) {
          a[0] = Number(a[0]) - (this.selected.stones.length)
        }
        if (Number(a[0]) < 0) {
          a[0] = Number(a[0]) + (this.selected.stones.length)
        }
        p[1] = a.join('.');
        return p.join('-P');
      } else {
        return src
      }
      return src
    },
    getRenders() {
      const productList = this.info?.request_config ? JSON.parse(JSON.stringify(this.info.request_config)) : [];
      const rendersSource = productList[0] || {};
      const renderViewKeys = rendersSource.images ? Object.keys(rendersSource.images).sort((a, b) => a.substring(1) - b.substring(1)) : [];
      let renderList = rendersSource.images ? this.convertRendersData(rendersSource.images) : [];
      renderList = renderList.map((item, index) => {
        let images = this.convertRendersData(item, 'x1');
        if (productList.length > 1) {
          productList.forEach((forItem, forIndex) => {
            if (forIndex && renderViewKeys[index] && forItem.images?.[renderViewKeys[index]]) {
              const mergedImage = forItem.images_merged?.main?.[renderViewKeys[index]];
              if (mergedImage) {
                images.push(mergedImage.webp || mergedImage.png);
              } else {
                images = images.concat(this.convertRendersData(forItem.images[renderViewKeys[index]], 'x1'));
              }
            }
          })
        }
        return {
          listType: 'render',
          renderIndex: index,
          images: this.isMilestone ? images.map((img) => this.rotateImages(img)): images
        }
      })
      if (this.isGiftCard) {
        renderList.splice(0,1);
      }
      return renderList;
    },
    convertRendersData(data, childKey) {
      return Object.keys(data).sort((a, b) => a.substring(1) - b.substring(1)).map(key => childKey ? data[key]?.[childKey] : data[key]);
    },
  }
}
